import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import App from './App';

const root = createRoot(document.getElementById('root'));

root.render(
    // <StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    // </StrictMode>
)